import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import demandService from '../../api/demandsService';

export default class ConfirmFinishCompany extends Component {
    constructor(props) {
        super(props);

        this.finishDemand = this.finishDemand.bind(this);
    }

    finishDemand() {
        const { id } = this.props.demand;
        demandService.finishDemand(id)
            .then(() => {
                this.props.onClose();
            });
    }

    render() {
        const { showConfirm, onClose, demand } = this.props;
        if (demand) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Finish this Demand?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            You are Finish?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back.</Button>
                        <Button onClick={this.finishDemand} color="primary" autoFocus>Yes, finish.</Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}